module.exports = __webpack_public_path__ + "static/SFMono-Medium-7df7729fbc66c426b3500d72bc140f5c.woff";